<template>
    <div>
        <message v-if="!HasConnection" :text="$t('text.errorNoServerConnection')"></message>
        <message v-if="HasConnection && !HasCompetitionData && !IsCompetitionLoading" :text="$t('text.noData')"></message>
        <message v-if="IsConnecting || HasConnection && IsCompetitionLoading">
            <div class="center"><loader></loader></div>
        </message>
        <div class="competition-wrapper f-row f-wrap" v-if="HasConnection && HasCompetitionData">
            <competition-card v-for="(comp, i) in CompetitionData" :key="i" :title="comp.name" :id="comp.id"></competition-card>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

import {mapActions, mapMutations, mapGetters } from 'vuex';
import glMut from '../store/mutations/global';
import compAct from '../store/actions/competition';
import compMut from '../store/mutations/competition';

import CompetitionCard from './CompetitionCard.vue';
import Message from './Message.vue';
import Loader from './Loader';

import * as signalR from '@aspnet/signalr';

export default {
    name: "competition-deck",
    data: function(){
        return {
            scl: {
                name: "SendCompetitionList",
                method: (data) => {
                    this.SETCOMPETITIONS(data);
                }
            }
            
        }
    },
    components: {
        CompetitionCard,
        Message,
        Loader,
    },
    computed: {   
        ...mapGetters(['Competitions', 'ConnectionState', 'IsCompetitionLoading', 'IsConnecting']),     
        CompetitionData () {
            return this.Competitions;
        },
        HasCompetitionData (){
            return this.CompetitionData && this.CompetitionData.length != 0;
        },
        HasConnection(){
            return this.Connection != "";
        },
    },
    methods: {
        ...mapMutations([
            compMut.SETCOMPETITIONS,
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB]),     
        ...mapActions([compAct.GETCOMPETITIONS]),   
        registerMethods(){
            this.REGISTERHUB(this.scl);
            this.GETCOMPETITIONS();
        }
    },
    watch: {
        ConnectionState(val) {
            if(val !== 0) {
                this.registerMethods();
            }
            else{
                this.UNREGISTERHUB(this.scl);
            }
        }
    },
    created(){
        if(this.ConnectionState !== 0){
            this.registerMethods();
        }
    },
    beforeDestroy(){
        this.UNREGISTERHUB(this.scl);
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .competition-wrapper {
        height:0px;
        // margin-right:-$spacer_default;
    }
</style>